import React from 'react';
import { HeatmapBand } from '../../services/inverterPowerService';

interface LegendBarProps {
  bands: HeatmapBand[];
}

const LegendBar: React.FC<LegendBarProps> = ({ bands }) => {
  return (
    <div className="flex items-center space-x-4">
      <span className="text-sm font-medium text-gray-700">Power (kW):</span>
      <div className="flex items-center space-x-2">
        {bands.map((band, index) => (
          <div key={index} className="flex items-center space-x-1">
            <div
              className="w-4 h-4 rounded border"
              style={{ backgroundColor: band.color_code }}
            />
            <span className="text-xs text-gray-600">
              {band.lower_bound}-{band.upper_bound}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LegendBar;